// extracted by mini-css-extract-plugin
module.exports = {"full":"style_full__kMGHH","container":"style_container__0Fw27","logo":"style_logo__WReJN","rotation":"style_rotation__y64X1","animateLoader":"style_animateLoader__tfvgb"};